import React, { useEffect } from "react";
import "./style.css";
import Typewriter from "typewriter-effect";
import HeroImg from "../../images/hero.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Hero() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <section className="Hero border-bottom d-flex align-items-center py-5" id="home">
      <div className="container h-100 mt-5">
        <div className="row h-100">
          <div className="col-md-6 col-12 d-flex align-items-center justify-content-md-start justify-content-center order-md-first order-last">
            <div className="Hero__content d-md-block d-flex flex-column align-items-center">
              <div
                className="Hero__content__heading fs-3 py-2"
                data-aos={"fade-right"}
                data-aos-offset={60}
                data-aos-once={true}
                data-aos-duration={1400}
              >
                _
                <span className="Hero__content__heading--color">
                  ashir
                </span>
              </div>
              <h1
                className="Hero__content__dynamic fs-1"
                data-aos={"fade-right"}
                data-aos-offset={60}
                data-aos-once={true}
                data-aos-duration={1400}
              >
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter.typeString("Web Developer").start();
                  }}
                />
              </h1>
              <p
                className="Hero__content__para text-md-start text-center"
                data-aos={"fade-right"}
                data-aos-offset={60}
                data-aos-once={true}
                data-aos-duration={1400}
              >
                As a front-end web developer, I am dedicated to creating
                intuitive and visually appealing interfaces. My passion lies in
                developing outstanding websites that has a positive impact on
                people's daily lives.
              </p>
              <a
                href="https://www.linkedin.com/in/muhammad-ashir-153135235/"
                className="Hero__content__button px-5 py-2 d-inline-block text-uppercase mt-3 text-decoration-none"
                data-aos={"fade-right"}
                data-aos-offset={60}
                rel="noreferrer"
                data-aos-once={true}
                data-aos-duration={1400}
                target="_blank"
              >
                Hire Me!
              </a>
            </div>
          </div>

          <div
            className="col-md-6 col-12 d-flex align-items-md-center align-items-end justify-content-center order-md-last order-first py-0 Hero__right"
            data-aos={"fade-right"}
            data-aos-offset={60}
            data-aos-once={true}
            data-aos-duration={1400}
          >
            <div className="Hero__right__container">
              <img
                alt=""
                srcSet={HeroImg}
                className="Hero__right__container__img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
